export default function accordionWithSliderController() {
  const swiperElement = document.querySelector('.accordion-slider .swiper');

  if (!swiperElement) {
    return;
  }

  const swiper = new Swiper(swiperElement, {
    slidesPerView: 1.2,
    spaceBetween: 20,
    mousewheel: true,
    loop: false,
    height: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    breakpoints: {
      768: {
        slidesPerView: 2.4,
      },
      480: {
        slidesPerView: 1.2,
      },
    },
  });
  swiper.on('lock', () => {
    swiperElement.classList.add('swiper--locked');
  });

  swiper.on('unlock', () => {
    swiperElement.classList.remove('swiper--locked');
  });
}
